// extracted by mini-css-extract-plugin
module.exports = {"container":"StaticImage_container__3b_Uk","buttonContainer":"StaticImage_buttonContainer__EMNNW"};